import { useEffect } from 'react'
import { translations } from '../utils/textosMeetingComponent'

interface WaitingRoomObserverProps {
  brand: string
  language: string
}

/**
 * Component to customize the waiting room according to brand
 */
const WaitingRoomObserver = ({ brand, language }: WaitingRoomObserverProps) => {
  useEffect(() => {
    const observeWaitingRoomBackground = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const waitingRoomBg = document.querySelector(
              '.wr-default-bg.wr-bg-full-screen',
            )
            if (waitingRoomBg instanceof HTMLImageElement) {
              const logoPath =
                brand === 'vidacaixa'
                  ? `${window.location.origin}/assets/images/caixa-logo.png`
                  : `${window.location.origin}/assets/images/qida-logo.png`

              if (waitingRoomBg.src !== logoPath) {
                waitingRoomBg.src = logoPath
                console.log(
                  `Fondo de sala de espera reemplazado con logo de ${brand}`,
                )
              }
            }

            const simpleWaitingRoomBg = document.querySelector(
              '.wr-default-bg:not(.wr-bg-full-screen)',
            )
            if (simpleWaitingRoomBg instanceof HTMLImageElement) {
              const logoPath =
                brand === 'vidacaixa'
                  ? `${window.location.origin}/assets/images/caixa-logo.png`
                  : `${window.location.origin}/assets/images/qida-logo.png`

              if (simpleWaitingRoomBg.src !== logoPath) {
                simpleWaitingRoomBg.src = logoPath
              }
            }

            const wrTopicElement = document.querySelector('.wr-topic')
            if (wrTopicElement) {
              const lang = translations[language as keyof typeof translations]
                ? language
                : 'es'
              const texts = translations[lang as keyof typeof translations]
              const brandTitle =
                brand === 'vidacaixa' ? texts.titleCaixa : texts.titleQida

              if (wrTopicElement.textContent !== brandTitle) {
                wrTopicElement.textContent = brandTitle
                console.log(
                  `Texto de sala de espera cambiado según brand: ${brand}`,
                )
              }
            }
          }
        })
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })

      return observer
    }

    const bgObserver = observeWaitingRoomBackground()

    return () => {
      bgObserver.disconnect()
    }
  }, [brand, language])

  return null
}

export default WaitingRoomObserver
